import { render } from "./SkeletonLoader.vue?vue&type=template&id=5f5114f0&scoped=true"
import script from "./SkeletonLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonLoader.vue?vue&type=style&index=0&id=5f5114f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5114f0"],['__file',"src/components/SkeletonLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f5114f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f5114f0', __exports__)) {
    api.reload('5f5114f0', __exports__)
  }
  
  module.hot.accept("./SkeletonLoader.vue?vue&type=template&id=5f5114f0&scoped=true", () => {
    api.rerender('5f5114f0', render)
  })

}


export default __exports__